import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../../../util/reactIntl';
import { ensureCurrentUser } from '../../../../util/data';
import { PrimaryButton } from '../../../../components';

import css from '../SignupWizard.module.css';

const VerifyEmailStep = props => {
  const {
    formData,
    currentUser,
    onResendVerificationEmail,
    sendVerificationEmailInProgress,
    onSkip,
  } = props;

  const user = ensureCurrentUser(currentUser);
  const email = user?.attributes?.email || formData.email;
  const firstName = user?.attributes?.profile?.firstName || formData.firstName;

  return (
    <div className={css.verifyEmailContent}>
      <p className={css.verifyEmailText}>
        <FormattedMessage
          id="SignupWizard.verifyEmailMessage"
          values={{
            name: firstName,
            email: <strong>{email}</strong>,
          }}
        />
      </p>

      <div className={css.bottomWrapper}>
        <PrimaryButton
          type="button"
          onClick={onResendVerificationEmail}
          inProgress={sendVerificationEmailInProgress}
        >
          <FormattedMessage id="SignupWizard.resendVerification" />
        </PrimaryButton>

        {onSkip && (
          <button
            type="button"
            className={css.skipButton}
            onClick={onSkip}
          >
            <FormattedMessage id="SignupWizard.skipVerification" />
          </button>
        )}
      </div>
    </div>
  );
};

VerifyEmailStep.defaultProps = {
  currentUser: null,
  sendVerificationEmailInProgress: false,
  onSkip: null,
};

VerifyEmailStep.propTypes = {
  formData: PropTypes.object.isRequired,
  currentUser: PropTypes.object,
  onResendVerificationEmail: PropTypes.func.isRequired,
  sendVerificationEmailInProgress: PropTypes.bool,
  onSkip: PropTypes.func,
};

export default VerifyEmailStep;
